import { CloseButton, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import styles from './styles.module.css';

export const MobileHeader = ({
	title,
	onBack,
	onClose,
}: {
	title: string;
	onBack?: () => void;
	onClose?: () => void;
}) => {
	return (
		<div className={styles.workflowMobileHeader}>
			<div className={styles.workflowMobileHeaderPrimaryContent}>
				{onBack && (
					<div className={styles.touchSurface} onClick={onBack}>
						<IconArrowLeft />
					</div>
				)}
				<Text c="blue.9" className={styles.title}>
					{title}
				</Text>
			</div>
			{onClose && (
				<div className={styles.touchSurface} onClick={onClose}>
					<CloseButton c="black" size="lg" />
				</div>
			)}
		</div>
	);
};
